// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tx2c","footer":"styles_footer__3bw0U","passCodeTooltip":"styles_passCodeTooltip__2RWkC"};